module.exports = __webpack_public_path__ + "img/success.a51512cb.svg";